<template>
    <div id="GpPrompt">
        <div class="content-container border-brand-primary text-prompt-container d-flex flex-column align-items-center animate__animated animate__fadeIn">
            <h3 class="pb-5 brand-text align-self-center">Based on your symptoms, you should speak to <span v-if="type !== 'anp'">a</span><span v-else>an</span> {{expertTypes[type].type}}</h3>
            <div class="card">
                <div class="d-flex flex-row align-items-center justify-content-start pb-4 recommended"><i class="fas fa-circle brand-primary pr-2"> </i> <span class="">Recommended</span></div>
                <h4 class="card-title">Book with <span v-if="type !== 'anp'">a</span><span v-else>an</span> {{expertTypes[type].type}}</h4>
                <p class="pb-3">{{expertTypes[type].text}}</p>
            </div>
            <div class="warning-info-container border-brand-primary d-flex flex-row justify-content-start align-items-center mt-3 w-100" v-if="type === 'anp'">
                <i class="fa-solid fa-circle-question brand-primary fa-2x mr-4"></i>
                <div>
                    <h4 class="mb-3">Are you pregnant?</h4>
                    <p class="pb-0 mb-0">If you're pregnant, please <a id="book-gp-appointment-pregnant-anp-override" class="brand-primary" @click="nextQuestion('gp')">book an appointment with a GP.</a></p>
                </div>
            </div>
            <div class="text-center" v-if="type !== 'gp'">
                If you think it's more appropriate, you can <a id="book-gp-appointment-anp-override" class="brand-primary" @click="nextQuestion('gp')">book with a GP</a> instead
            </div>
        </div>
    </div>
</template>
<script>

export default {
    components: {

    },
    name: "GpPrompt",
    data() {
        return {
            expertTypes: {'gp': {title: 'Based on your symptoms, you should speak to a GP', text: 'They can help with a range of illnesses and health concerns, prescribe medication and refer you for further treatment if necessary.', type: 'GP'},
                          'anp':  {title: 'Based on your symptoms, you should speak to an advanced nurse practitioner', text: 'They can help with a range of illnesses and health concerns, prescribe medication and refer you for further treatment if necessary.', type: 'advanced nurse practitioner'},
                          'physio': {title: 'Based on your symptoms, you should speak to an physio', text: 'They can diagnose and help treat muscle, bone and joint issues. They may provide tailored exercises and physical activity advice or refer you for further treatment if necessary.', type: 'physio'},
                          'mh': {title: 'Based on your symptoms, you should speak to an physio', text: 'They can give advice and support for any conditions affecting your mental health, and refer you for further treatment if neccessary.', type: 'mental health practitioner'}, 
                        }
        };
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {

    },
    props: ['type', 'nextQuestion'],

};
</script>
<style lang="less">
#GpPrompt {
    a{
        text-decoration: underline;
    }
    .recommended{
        font-weight: 500;
        font-size: 1.4rem;
    }
    .text-prompt-container {
        max-width: 700px;
        font-size: 1.6rem;

        h3 {
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
            font-size: 1.8rem;
            text-align: center;
        }
        .card{
            background-color: white;
            padding: 15px;
            border-radius: 16px;
            margin-bottom: 20px;
            .card-title{
                font-size: 1.6rem;
                margin-bottom: 0;
                padding-bottom: 15px;
            }
        }
        a{
            font-weight: 500;
        }
        .mobile-only-link{
            cursor: default;
        }
        .warning-info-container {
            font-family: "Montserrat", serif;
            background-color: white;
            padding: 20px;
            border: 2px solid #0079c8;
            border-radius: 16px;
            margin-bottom: 25px;
        }
    }
}
</style>